;(function () {
  const container = document.querySelector('.search-results-form-wrapper')
  if (!container) return

  const inputEl = container.querySelector('.js-header-search-details-input')
  const submitEl = container.querySelector('.js-header-search-details-submit')
  const formEl = container.querySelector('.header-v2-search__form')

  if (!inputEl || !submitEl || !formEl) return

  // Enable / Disable button
  const handleChange = () => {
    if (inputEl.value.trim()) {
      submitEl.removeAttribute('disabled')
    } else {
      submitEl.setAttribute('disabled', true)
    }
  }

  inputEl.addEventListener('input', handleChange)

  formEl.addEventListener('submit', (e) => {
    e.preventDefault()

    const query = inputEl.value.trim()
    if (!query) return
  })

  onTagalysReady(function () {
    Tagalys.UIWidgets.SearchSuggestions.init(
      '.search-results-form-wrapper .header-v2-search__input',
      {
        searchResultsURL: '/pages/search-results',
        templates: {
          widget: {
            options: {
              selector: '.search-results-related-wrapper',
              alignToSelector: '.search-results-related-wrapper',
              interactionSelectors: [
                '#main',
                '#shopify-section-header-v2',
                '.ldt-cp-App-Content',
                '.ldt-cp-Modal',
                '.ldt-cp-Modal__Footer',
              ],
              sections: {
                popular_searches: {
                  count: 10,
                },
              },
            },
          },
          hint: {
            render: function (html, args) {
              var props = args.props
              var helpers = props.helpers
              var widgetOptions = helpers.getTemplateOptions('widget')

              return
            },
          },
          clickSuggestions: {
            render: function (html, args) {
              var helpers = args.props.helpers
              var recentAndPopularSearches =
                helpers.getRecentAndPopularSearches()

              return html``
            },
          },

          typeSuggestions: {
            render: function (html, args) {
              var props = args.props
              var helpers = props.helpers
              var textSuggestions = helpers.getTextSuggestions()

              var classes = ['type-suggestions']
              if (helpers.hasTextSearchSuggestions() > 0) {
                classes.push('product-and-text-suggestions')
              } else {
                classes.push('product-suggestions')
              }
              var className = classes.join(' ')

              return html` <div class=${className}>
                ${helpers.hasTextSearchSuggestions()
                  ? html`
                      <ul class="text-suggestions">
                        ${textSuggestions.map(
                          (textSuggestionSection) => html`
                            <${args.templates.textSuggestionSection}
                              textSuggestionSection=${textSuggestionSection}
                            />
                          `
                        )}
                      </ul>
                    `
                  : null}
                <${args.templates.products} class="product-suggestions" />
              </div>`
            },
          },

          textSuggestionSection: {
            render: function (html, args) {
              var props = args.props
              var textSuggestionSection = props.textSuggestionSection

              if (textSuggestionSection.items.length > 0) {
                return html`
                  <li
                    class="text-suggestion-section"
                    data-section-id=${textSuggestionSection.id}
                  >
                    <span class="section-title"> Related searches </span>

                    <header-search-suggestion-scroller
                      class="text-suggestion-section-wrapper"
                    >
                      <ul
                        class="text-suggestion-section-list js-search-horizontal-scroll"
                      >
                        ${textSuggestionSection.items.map(
                          function (textSuggestionSectionItem) {
                            return html`
                              <${args.templates.textSuggestionSectionItem}
                                textSuggestionSectionId=${textSuggestionSection.id}
                                textSuggestionSectionItem=${textSuggestionSectionItem}
                              />
                            `
                          }
                        )}
                      </ul>
                      <button class="scroll-right">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M9.75 7.5L14.25 12L9.75 16.5"
                            stroke="white"
                            stroke-width="1.5"
                          />
                        </svg>
                      </button>
                    </header-search-suggestion-scroller>
                  </li>
                `
              }
              return null
            },
          },
        },
      }
    )
  })
})()

function getThemeSchema(filterThemeConfig) {
  const {
    two_column_filters,
    show_more_values_limit,
    color_swatch_with_dark_checkmark,
    color_swatch_with_gray_border,
    theme_style,
    tooltip_map,
    badge_map,
    yotpo_stars_instance_id,
  } = filterThemeConfig

  onTagalysReady(function () {
    const container = document.querySelector('.tagalys-search-results')
    if (!container) {
      console.error('❌ Tagalys container not found')
      return
    }

    const tagalysConfig = window.__TAGALYS_CURRENCY_CONTEXT__
    if (!window.Tagalys || !tagalysConfig) return

    const urlParams = new URLSearchParams(window.location.search)
    const searchQuery = urlParams.get('query') || ''

    const searchResultsSelector = '.tagalys-search-results'
    const searchResultsParams = {
      query: searchQuery,
      facets: true,
      showSortOptions: true,
      limit: 18,
    }

    const searchImpressionTracker = createSearchImpressionTracker(
      'Search Results'
    )
    let lastSearchContextKey = null
    let pendingImpressionRescanTimer = null

    const searchResultsCallbacks = {
      onSuccessfulAPICall: (response, helpers) => {
        const query = helpers?.getQuery?.()

        // Fire dl_view_search_results only when the query, filters, or sort
        // actually change — not on every onSuccessfulAPICall. Pagination
        // (load more) keeps this same context and returns a larger product
        // list under it, so it correctly does NOT refire a search event
        // (matching how the header modal only fires on a changed query);
        // newly-loaded products are still reported via dl_view_item_list.
        // This also suppresses the SDK occasionally calling
        // onSuccessfulAPICall twice for one action, since both calls share
        // the same context.
        const contextKey = JSON.stringify([
          query,
          helpers?.getAppliedFilters?.(true),
          helpers?.getAppliedSortOption?.(),
        ])
        if (contextKey !== lastSearchContextKey) {
          lastSearchContextKey = contextKey
          searchImpressionTracker.reset()
          if (query) {
            pushSearchResultsDataLayerEvent(query)
          }
        }

        return response
      },
      afterEveryRender: (helpers) => {
        const resultsRoot = document.querySelector(searchResultsSelector)
        if (resultsRoot) {
          scanSearchResultsForImpressions(
            helpers?.getProducts?.() || [],
            resultsRoot,
            searchImpressionTracker
          )
        }

        // Some cards can finish rendering slightly after this callback
        // fires (e.g. a staggered/animated reveal on filter or sort
        // change) — a short follow-up rescan catches any that were missed
        // on the first pass. Safe to repeat: already-observed cards are
        // skipped.
        if (pendingImpressionRescanTimer) {
          clearTimeout(pendingImpressionRescanTimer)
        }
        pendingImpressionRescanTimer = setTimeout(() => {
          pendingImpressionRescanTimer = null
          const root = document.querySelector(searchResultsSelector)
          if (root) {
            scanSearchResultsForImpressions(
              helpers?.getProducts?.() || [],
              root,
              searchImpressionTracker
            )
          }
        }, 500)
      },
    }

    const shopifySearchSortOptions = [
      {
        id: 'relevance',
        label: 'Recommended',
      },
      {
        id: 'price-asc',
        label: 'Price, low to high',
      },
      {
        id: 'price-desc',
        label: 'Price, high to low',
      },
    ]

    const searchResultsTemplates = {
      widget: {
        options: {
          includeTagalysCSS: false,
          perPage: 18,
        },
      },

      noResults: {
        options: {
          widgets: [],
        },

        widget: {
          options: { includeTagalysCSS: false, perPage: 18 },
        },
        render: function (html, args) {
          var labels = args.labels
          return html`
            <div class="no-results">
              <h1 class="no-results-heading">
                ${labels.searchResults.noResultsHeading}
              </h1>
              <${args.templates.noResultsWidgets} />
            </div>
          `
        },
      },

      pagination: {
        options: {
          infiniteScroll: true,
          showLoadNextAfterEvery: 1,
        },

        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers

          if (props.infiniteScroll) {
            if (helpers.canLoadNextResults(props.showLoadNextAfterEvery)) {
              return html`<${args.templates.loadNext} />`
            }
            return null
          }
          return html` <${args.templates.paginationLinks} /> `
        },
      },

      loadNext: {
        render: function (html, args) {
          const props = args.props
          const helpers = props.helpers
          const labels = args.labels

          const products = helpers.getProducts() || []
          const shown = products.length
          const total = helpers.getTotalProductsCount() || 0
          const percent = total ? (shown / total) * 100 : 0

          return html`
            <div class="search-landing__pagination-container">
              ${helpers.hasNextPage()
                ? html`
                    <button
                      type="button"
                      class="button button--secondary search-landing__load-more-btn"
                      disabled=${helpers.isLoading() ? 'disabled' : null}
                      onclick=${(event) => {
                        const result = helpers.loadNextPage(event)
                        const rescanForImpressions = () => {
                          const resultsRoot = document.querySelector(
                            searchResultsSelector
                          )
                          if (resultsRoot) {
                            scanSearchResultsForImpressions(
                              helpers.getProducts() || [],
                              resultsRoot,
                              searchImpressionTracker
                            )
                          }
                        }
                        if (result && typeof result.then === 'function') {
                          result.then(rescanForImpressions)
                        } else {
                          setTimeout(rescanForImpressions, 400)
                        }
                      }}
                    >
                      <span>${labels.pagination.loadNext}</span>

                      <span class="icon-arrow">
                        ${helpers.isLoading()
                          ? html`
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                aria-hidden="true"
                              >
                                <use
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  xlink:href="#icon-loading-spinner"
                                ></use>
                              </svg>
                            `
                          : html`
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                aria-hidden="true"
                              >
                                <use xlink:href="#icon-arrow-down"></use>
                              </svg>
                            `}
                      </span>
                    </button>
                  `
                : ''}
              ${shown > 0
                ? html`
                    <div class="load-more__progress-wrapper">
                      <div class="load-more__progress-bar">
                        <span
                          class="load-more__progress-indicator"
                          style="width: ${percent}%;"
                        ></span>
                      </div>
                      <p class="load-more__progress-count" role="status">
                        Viewing ${shown} of ${total}
                      </p>
                    </div>
                  `
                : ''}
            </div>
          `
        },
      },

      appliedFilters: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers

          var appliedFilters = helpers.getAppliedFilters(true)
          if (!appliedFilters.length) return null
          return html``
        },
      },

      infoAndActions: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers
          var labels = args.labels
          var filterOptions = helpers.getTemplateOptions('filters')

          var getResultsLabel = () => {
            return labels.searchResults.productsCount.replace(
              '{{productsCount}}',
              helpers.getTotalProductsCount()
            )
          }

          return html`
            <div class="plp-info-and-actions">
              ${filterOptions.includeSortOptionsInFilters
                ? null
                : html` <${args.templates.sortOptions} /> `}
            </div>
          `
        },
      },

      sortOptions: {
        render: function (html, args) {
          var props = args.props
          var labels = args.labels
          var helpers = props.helpers
          var sortOptions = helpers.getSortOptions()
          var appliedSortOption = helpers.getAppliedSortOption()

          var applySortOption = (event) => {
            helpers.applySortOption(event.target.value)
          }

          return html`
            <div class="search-landing__sort-wrapper">
              <custom-dropdown class="search-landing__sort-dropdown">
                <button
                  type="button"
                  class="button-reset search-landing__sort-dropdown-button"
                  data-toggle=""
                >
                  <span data-label="Sort by">Sort by</span>
                  <span
                    ><svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      aria-hidden="true"
                    >
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="#icon-chevron-down"
                      ></use></svg
                  ></span>
                </button>

                <ul class="search-landing__sort-dropdown-list">
                  ${(() => {
                    const selectedSortId =
                      appliedSortOption && appliedSortOption.id
                        ? appliedSortOption.id
                        : sortOptions[0]?.id

                    return sortOptions.map((sortOption) => {
                      const isSelected = selectedSortId === sortOption.id

                      return html`
                        <li class="search-landing__sort-dropdown-item">
                          <input
                            id="sort-by-${sortOption.id}"
                            type="radio"
                            name="search-result-sort-By"
                            class="visually-hidden search-landing__sort-dropdown-item-radio"
                            value=${sortOption.id}
                            checked=${isSelected}
                            onchange=${applySortOption}
                            data-input-label=${sortOption.label}
                          />

                          <label
                            for="sort-by-${sortOption.id}"
                            class="search-landing__sort-dropdown-item-label"
                          >
                            <span>${sortOption.label}</span>

                            ${isSelected
                              ? html`
                                  <span
                                    class="search-landing__sort-dropdown-item-check"
                                  >
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 12 12"
                                      aria-hidden="true"
                                    >
                                      <use xlink:href="#icon-check"></use>
                                    </svg>
                                  </span>
                                `
                              : ''}
                          </label>
                        </li>
                      `
                    })
                  })()}
                </ul>
              </custom-dropdown>
            </div>
          `
        },
      },

      heading: {
        options: {
          selector: '.search-results-product-count',
        },
        render: function (html, args) {
          var props = args.props
          var labels = args.labels
          var helpers = props.helpers

          var getHeadingBasedOnAPIResponse = () => {
            if (helpers.isPartialResults()) {
              return labels.searchResults.heading.partialMatches.replace(
                '{{searchTerm}}',
                helpers.getQuery()
              )
            }

            if (helpers.isSpellingCorrectedQuery()) {
              return labels.searchResults.heading.corrected
                .replace('{{originalSearchTerm}}', helpers.getOriginalQuery())
                .replace('{{resultsCount}}', helpers.getTotalProductsCount())
                .replace('{{correctedSearchTerm}}', helpers.getQuery())
            }

            return labels.searchResults.heading.standard
              .replace('{{resultsCount}}', helpers.getTotalProductsCount())
              .replace('{{searchTerm}}', helpers.getQuery())
          }

          return html`
            <div class="search-landing__header">
              <div class="search-landing__header-content">
                <div class="search-landing__header-info">
                  <div class="search-landing__header-details">
                    <div class="search-landing__results-message">
                      ${getHeadingBasedOnAPIResponse()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `
        },
      },

      productListHeader: {
        render: function (html, args) {
          return html``
        },
      },

      filters: {
        render: function (html, args) {
          var props = args.props
          var labels = args.labels
          var helpers = props.helpers

          var getHeadingBasedOnAPIResponse = () => {
            const resultsCount = helpers.getTotalProductsCount()

            return `Showing: ${resultsCount} Products`
          }

          var sortOptions = helpers.getSortOptions()
          var appliedSortOption = helpers.getAppliedSortOption()

          var applySortOption = (event) => {
            helpers.applySortOption(event.target.value)
          }

          var filters = helpers.getFilters()
          var appliedFilters = helpers.getAppliedFilters(true)
          var showClearAllFiltersAction =
            props.showClearAllFilters && appliedFilters.length
          var classes = [
            'filters',
            'search-landing-page-filters',
            'search-landing__filter-drawer-panel',
          ]
          if (props.collapsible) {
            classes.push('collapsible')
          }
          const selectedCount = appliedFilters.reduce(
            (total, filter) =>
              total +
              (filter.items?.filter((item) => item.selected).length || 0),
            0
          )

          var className = classes.join(' ')
          return html`
            <search-landing-filters class="search-landing__header-facets">
              <div class="search-landing__header-facets-desktop">
                <button
                  type="button"
                  class="button-reset search-landing__filter-button js-toggle-filter-button"
                >
                  <span>
                    <svg
                      width="18"
                      height="12"
                      viewBox="0 0 18 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                    >
                      <path
                        d="M0.986328 9.00317L9.04883 9.00317"
                        stroke="currentColor"
                      />
                      <path
                        d="M0.986328 9.00317L9.04883 9.00317"
                        stroke="currentColor"
                      />
                      <circle
                        cx="2.5625"
                        cy="2.5625"
                        r="2.0625"
                        transform="matrix(1 8.74228e-08 8.74228e-08 -1 10.4863 11.5657)"
                        fill="white"
                        stroke="currentColor"
                      />
                      <path
                        d="M17.7988 3.00317L9.73633 3.00317"
                        stroke="currentColor"
                      />
                      <path
                        d="M17.7988 3.00317L9.73633 3.00317"
                        stroke="currentColor"
                      />
                      <circle
                        cx="2.5625"
                        cy="2.5625"
                        r="2.0625"
                        transform="matrix(-1 -1.74846e-07 -1.74846e-07 1 8.29883 0.440674)"
                        fill="white"
                        stroke="currentColor"
                      />
                    </svg>
                  </span>
                  <span>
                    <span class="show-label">Show Filters</span>
                    <span class="hide-label">Hide Filters</span>
                  </span>
                </button>

                <div class="products-list-header">
                  ${args?.templates?.infoAndActions
                    ? html`<${args.templates.infoAndActions} />`
                    : ''}
                </div>
              </div>

              <div class="search-landing__header-facets-mobile">
                <button
                  type="button"
                  class="button-reset search-landing__filter-button js-toggle-filter-button"
                >
                  <span
                    ><svg
                      width="18"
                      height="12"
                      viewBox="0 0 18 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                    >
                      <path
                        d="M0.986328 9.00317L9.04883 9.00317"
                        stroke="currentColor"
                      ></path>
                      <path
                        d="M0.986328 9.00317L9.04883 9.00317"
                        stroke="currentColor"
                      ></path>
                      <circle
                        cx="2.5625"
                        cy="2.5625"
                        r="2.0625"
                        transform="matrix(1 8.74228e-08 8.74228e-08 -1 10.4863 11.5657)"
                        fill="white"
                        stroke="currentColor"
                      ></circle>
                      <path
                        d="M17.7988 3.00317L9.73633 3.00317"
                        stroke="currentColor"
                      ></path>
                      <path
                        d="M17.7988 3.00317L9.73633 3.00317"
                        stroke="currentColor"
                      ></path>
                      <circle
                        cx="2.5625"
                        cy="2.5625"
                        r="2.0625"
                        transform="matrix(-1 -1.74846e-07 -1.74846e-07 1 8.29883 0.440674)"
                        fill="white"
                        stroke="currentColor"
                      ></circle></svg
                  ></span>
                  <span>Filter & Sort</span>
                </button>
                <div class="search-landing-product-count">
                  <span> ${helpers.getTotalProductsCount()} </span> products
                </div>
              </div>
            </search-landing-filters>
            <search-landing-filter-drawer class="search-landing__filter-drawer">
              <div class=${className}>
                <div class="search-landing__filter-drawer-wrapper">
                  <${args.templates.filtersHeader} />

                  ${props.includeSortOptionsInFilters === 'top'
                    ? html` <${args.templates.sortOptionInFilters} /> `
                    : null}
                  <div class="search-landing__filter-drawer-content">
                    <div class="search-landing__filter-sort-mobile">
                      <summary class="search-filter-header flex">
                        <div class="flex aic"><span>Sort By</span></div>
                      </summary>

                      <ul class="search-landing__sort-dropdown-mobile">
                        ${(() => {
                          const selectedSortId =
                            appliedSortOption && appliedSortOption.id
                              ? appliedSortOption.id
                              : sortOptions[0]?.id

                          return sortOptions.map((sortOption) => {
                            const isSelected = selectedSortId === sortOption.id

                            return html`
                              <li
                                class="search-landing__sort-dropdown-item-mobile"
                              >
                                <input
                                  id="sort-by-${sortOption.id}"
                                  type="checkbox"
                                  name="sort_by"
                                  class=""
                                  value=${sortOption.id}
                                  checked=${isSelected}
                                  onchange=${applySortOption}
                                  data-input-label=${sortOption.label}
                                />

                                <label
                                  for="sort-by-${sortOption.id}"
                                  class="search-landing__sort-dropdown-item-label-mobile"
                                >
                                  <span>${sortOption.label}</span>
                                </label>
                              </li>
                            `
                          })
                        })()}
                      </ul>
                    </div>

                    ${filters.map(
                      (filter) =>
                        html`<${args.templates.filter} filter=${filter} />`
                    )}
                  </div>

                  <div
                    class="search-landing__filter-drawer-footer search-landing__filter-drawer__footer-button-group-mobile"
                  >
                    <div class="search-landing__results-message">
                      ${getHeadingBasedOnAPIResponse()}
                    </div>
                    <div
                      class="search-landing__filter-drawer-footer-button-group"
                    >
                      <a
                        href="#"
                        class="button button--secondary ${selectedCount === 0
                          ? 'disabled disabled-link'
                          : ''}"
                        onClick=${(event) => {
                          appliedFilters.forEach((appliedFilter) => {
                            appliedFilter.items
                              ?.filter((item) => item.selected)
                              .forEach((filterItem) => {
                                helpers.clearFilter(
                                  appliedFilter.id,
                                  filterItem.id
                                )
                              })
                          })

                          document
                            .querySelectorAll(
                              '.search-landing__filter-drawer-label.is-active'
                            )
                            ?.forEach((item) => {
                              item.classList.remove('is-active')
                            })
                        }}
                      >
                        Clear${selectedCount > 0 ? ` (${selectedCount})` : ''}
                      </a>

                      <button
                        type="button"
                        class="button button--primary search-landing__filter-drawer-footer-apply-button js-search-landing-filter-drawer-close"
                        aria-label="Close"
                      >
                        <span>Apply</span>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          aria-hidden="true"
                        >
                          <use
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xlink:href="#icon-arrow-right"
                          ></use>
                        </svg>
                      </button>
                    </div>
                  </div>

                  ${props.includeSortOptionsInFilters === true ||
                  props.includeSortOptionsInFilters === 'bottom'
                    ? html` <${args.templates.sortOptionInFilters} /> `
                    : null}
                </div>
              </div>
            </search-landing-filter-drawer>
          `
        },
      },

      filtersHeader: {
        render: function (html, args) {
          var props = args.props
          var labels = args.labels
          var helpers = props.helpers

          var filters = helpers.getFilters()
          var appliedFilters = helpers.getAppliedFilters(true)

          const selectedCount = appliedFilters.reduce(
            (total, filter) =>
              total +
              (filter.items?.filter((item) => item.selected).length || 0),
            0
          )

          return html`
            <div class="search-landing__filter-drawer-header">
              <div
                class="search-landing__filter-drawer-title search-landing__filter-drawer-title-desktop h6"
              >
                ${labels.filters.heading}
              </div>

              <div
                class="search-landing__filter-drawer-title search-landing__filter-drawer-title-mobile h6"
              >
                Filters & Sorting
              </div>

              <button
                type="button"
                class="button button--action-circle search-landing__filter-drawer-close-btn js-search-landing-filter-drawer-close"
                aria-label="Close"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  aria-hidden="true"
                >
                  <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#icon-close"
                  ></use>
                </svg>
              </button>

              <div
                class="search-landing__filter-drawer-footer-button-group search-landing__filter-drawer__footer-button-group-desktop"
              >
                <a
                  href="#"
                  class="button button--action-outline ${selectedCount === 0
                    ? 'disabled disabled-link'
                    : ''}"
                  onClick=${(event) => {
                    appliedFilters.forEach((appliedFilter) => {
                      appliedFilter.items
                        ?.filter((item) => item.selected)
                        .forEach((filterItem) => {
                          helpers.clearFilter(appliedFilter.id, filterItem.id)
                        })
                    })

                    document
                      .querySelectorAll(
                        '.search-landing__filter-drawer-label.is-active'
                      )
                      ?.forEach((item) => {
                        item.classList.remove('is-active')
                      })

                    helpers.clearFilter(
                      'p.m.search._derived_field_available',
                      'true'
                    )
                  }}
                >
                  Clear${selectedCount > 0 ? ` (${selectedCount})` : ''}
                </a>
              </div>
            </div>
          `
        },
      },
      filterHeader: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers
          var filterOptions = helpers.getTemplateOptions('filters')

          const toggleCollapsibleFilter = () => {
            helpers.toggleCollapsibleFilter(props.filterId)
          }

          // ---- helpers ----
          const handleize = (str = '') =>
            str
              .toLowerCase()
              .trim()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-|-$/g, '')

          // Skip Stock status
          if (props.filterHeading === 'Stock status') {
            return null
          }

          const title = props.filterHeading
          const modalId = handleize(`filter-${title}-top-level-tooltip`)
          const broadcastData = JSON.stringify({ id: modalId })
          const headingId = handleize(`filter-${title}-heading`)

          // Replace later with real data
          const filterHandle = handleize(props.filterHeading)
          const tooltipKey = `${props.filterHeading}::`
          const tooltipDescription =
            tooltip_map?.[tooltipKey]?.description?.children?.[0]?.children?.[0]
              ?.value || null
          return html`
            <summary
              id="${headingId}"
              onclick=${filterOptions.collapsible
                ? toggleCollapsibleFilter
                : undefined}
              class="filter-header search-landing__filter-drawer-summary flex"
            >
              ${tooltipDescription
                ? html`
                    <div data-tooltip-parent class="flex aic">
                      <span>${title}</span>

                      <!-- Desktop tooltip icon -->
                      <div
                        data-filter-option-tooltip-icon
                        data-filter-option-tooltip-icon-desktop
                        data-filter-option-toplevel-tooltip
                        class="collection-filter-drawer__filter-tooltip-icon hidden--sm"
                        tabindex="0"
                        onclick=${(e) => e.stopPropagation()}
                      >
                        <span class="visually-hidden">${title}</span>
                        <svg width="16" height="16" aria-hidden="true">
                          <use xlink:href="#icon-info"></use>
                        </svg>
                      </div>

                      <!-- Desktop tooltip content -->
                      <div
                        role="tooltip"
                        data-filter-option-tooltip-content-desktop
                        class="collection-filter-drawer__filter-tooltip-content hidden--sm"
                      >
                        <div
                          class="collection-filter-drawer__filter-tooltip-heading"
                        >
                          ${title}
                        </div>
                        <div
                          class="collection-filter-drawer__filter-tooltip-description"
                        >
                          ${tooltipDescription}
                        </div>
                      </div>

                      <!-- Mobile trigger -->
                      <hh-broadcast
                        event="modal"
                        data=${JSON.stringify({ id: modalId })}
                        class="hidden--md hidden--lg"
                        tabindex="0"
                        onclick=${(e) => e.stopPropagation()}
                      >
                        <div
                          data-filter-option-tooltip-icon
                          data-filter-option-tooltip-icon-mobile
                          data-filter-option-toplevel-tooltip
                          class="collection-filter-drawer__filter-tooltip-icon"
                        >
                          <svg width="16" height="16" aria-hidden="true">
                            <use xlink:href="#icon-info"></use>
                          </svg>
                        </div>
                      </hh-broadcast>

                      <!-- Mobile modal -->
                      <hh-modal
                        id="${modalId}"
                        show-close="false"
                        for-data-filter-option-tooltip="true"
                        data-filter-option-tooltip-content-mobile
                        class="hidden--md hidden--lg"
                      >
                        <div
                          class="collection-filter-drawer__filter-tooltip-content-mobile"
                          tabindex="0"
                        >
                          <div
                            class="collection-filter-drawer__filter-tooltip-heading"
                          >
                            ${title}
                          </div>
                          <div
                            class="collection-filter-drawer__filter-tooltip-description"
                          >
                            ${tooltipDescription}
                          </div>
                        </div>
                      </hh-modal>
                    </div>
                  `
                : html`<span>${title}</span>`}
            </summary>
          `
        },
      },

      filter: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers
          var classes = ['filter', 'search-landing__filter-drawer-detail']
          var isCollapseOpen = false
          if (props.collapsible) {
            isCollapseOpen = helpers.isCollapsibleFilterExpanded(
              props.filter.id
            )
            isCollapseOpen
              ? classes.push('expanded')
              : classes.push('collapsed')
          }

          var className = classes.join(' ')
          return html`
            ${props.filter.id === '_derived_field_available'
              ? html`
                  <div
                    class=${className}
                    data-filter-id=${props.filter.id}
                    data-filter=${props.filter.id}
                  >
                    <${args.templates.filterHeader}
                      filterHeading=${props.filter.label}
                      filterId=${props.filter.id}
                    />

                    <${args.templates.filterItems} filter=${props.filter} />
                  </div>
                `
              : html`
                  <details
                    class=${className}
                    data-filter-id=${props.filter.id}
                    data-filter=${props.filter.id}
                    open
                  >
                    <${args.templates.filterHeader}
                      filterHeading=${props.filter.label}
                      filterId=${props.filter.id}
                    />

                    <${args.templates.filterItems} filter=${props.filter} />
                  </details>
                `}
          `
        },
      },

      filterCheckBoxes: {
        render: function (html, args) {
          const props = args.props

          const DEFAULT_MAX_VISIBLE = 4
          const cleanFilterId = props.filterId.replace(
            /^p\.m\.(search|specs|filter|merchandise)\./,
            ''
          )
          const handleize = (str = '') =>
            str
              .toLowerCase()
              .trim()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-|-$/g, '')
          const headingId = handleize(`filter-${cleanFilterId}-heading`)

          let MAX_VISIBLE = DEFAULT_MAX_VISIBLE

          const limitConfig = filterThemeConfig?.show_more_values_limit

          if (limitConfig && limitConfig.includes(cleanFilterId)) {
            const match = limitConfig.match(
              new RegExp(`${cleanFilterId}\\s*:\\s*(\\d+)`)
            )

            if (match && match[1]) {
              MAX_VISIBLE = Number(match[1])
            }
          }

          const totalItems = props.filterItems.length
          const extraItems = totalItems - MAX_VISIBLE
          const shouldCollapse = extraItems > 2

          const normalize = (str = '') =>
            str
              .toLowerCase()
              .trim()
              .replace(/[_\s]+/g, '-')

          const normalizedFilterId = normalize(cleanFilterId)

          const isTwoColumn = (filterThemeConfig?.two_column_filters || '')
            .split(',')
            .map(normalize)
            .includes(normalizedFilterId)

          return html`
            <div
              class="search-landing__filter-drawer-display"
              role="group"
              aria-labelledby="${headingId}"
            >
              <ul
                class="search-landing__filter-drawer-list filter-column-${cleanFilterId}  ${isTwoColumn
                  ? 'filter-two-column'
                  : ''}"
              >
                ${props.filterItems.map(
                  (filterItem, index) => html`
                    <${args.templates.checkboxFilterItem}
                      filterId=${props.filterId}
                      filterItem=${filterItem}
                      itemIndex=${index}
                      isHidden=${shouldCollapse && index >= MAX_VISIBLE}
                    />
                  `
                )}
              </ul>

              ${shouldCollapse
                ? html`
                    <button
                      type="button"
                      class="filter-show-more"
                      data-expanded="false"
                      onClick=${(e) => {
                        const wrapper = e.currentTarget.closest(
                          '.search-landing__filter-drawer-display'
                        )

                        wrapper.classList.toggle('is-expanded')

                        const expanded =
                          wrapper.classList.contains('is-expanded')

                        e.currentTarget.textContent = expanded
                          ? ''
                          : `Show ${extraItems} more options`
                      }}
                    >
                      Show ${extraItems} more options
                    </button>
                  `
                : null}
            </div>
          `
        },
      },

      checkboxFilterItem: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers

          const isInStockFilter = props.filterItem.id === 'true'
          const isHidden = props.isHidden

          const cleanFilterId = props.filterId.replace(
            /^p\.m\.(search|specs|filter|merchandise)\./,
            ''
          )
          const checkboxId = `filter-${cleanFilterId}-${props.filterItem.id}`

          const swatchName = props.filterItem.id
            .toLowerCase()
            .replace(/_slash_/gi, '---')
            .replace(/slash/gi, '---')
            .replace(/\//g, '---')
            .replace(/[_\s&]+/g, '-')
            .replace(/^-|-$/g, '')

          const onFilterClick = (event) => {
            if (props.filterItem.selected) {
              helpers.clearFilter(props.filterId, props.filterItem.id)
            } else {
              helpers.applyFilter(props.filterId, props.filterItem.id)
            }
          }

          const darkCheckmarkColors = new Set(
            (filterThemeConfig.color_swatch_with_dark_checkmark || '')
              .split(',')
              .map((c) => c.trim().toLowerCase())
          )

          const handleize = (str = '') =>
            str
              .toLowerCase()
              .trim()
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-|-$/g, '')

          const capitalize = (str = '') =>
            str
              .trim()
              .toLowerCase()
              .replace(/\b\w/g, (c) => c.toUpperCase())

          const title = cleanFilterId
          const innerToolTipHandle = `${cleanFilterId}--`

          const modalId = handleize(`filter-${title}-top-level-tooltip`)
          const broadcastData = JSON.stringify({
            id: modalId,
          })

          const filterHandle = handleize(title)
          const tooltipData = `${capitalize(title)}::${capitalize(props.filterItem.label)}:`

          const propsLabelData = props.filterItem.label.toLowerCase()
          const tooltipKey = tooltipData.replace(/:$/, '')
          const tooltipDescription =
            tooltip_map?.[tooltipKey]?.description.children[0]?.children[0]
              ?.value || null

          return html`
            ${props.filterItem.id !== 'false'
              ? html`
                  <li
                    class="list-menu__item collection-filter-drawer__filter-item filter-item ${isHidden
                      ? 'is-hidden'
                      : ''}"
                    role="option"
                    data-filter-item-id=${props.filterItem.id}
                    onclick=${onFilterClick}
                  >
                    ${isInStockFilter
                      ? html`
                          <div
                            class="search-component-toggle"
                            data-filter-id="${props.filterId}"
                            data-filter-item-id="${props.filterItem.id}"
                            data-checked="${props.filterItem.selected
                              ? 'true'
                              : 'false'}"
                          >
                            <input
                              type="checkbox"
                              id="filter-in-stock-${props.filterItem.id}"
                              name="${props.filterItem.id}"
                              value="1"
                              class="collection-filter-drawer__filter-checkbox hidden"
                              ${props.filterItem.selected ? 'checked' : ''}
                            />
                            <button
                              type="button"
                              role="switch"
                              aria-checked="${props.filterItem.selected}"
                              aria-label="Only Show In Stock Items"
                            >
                              <span
                                class="search-component-toggle__thumb"
                              ></span>
                            </button>
                            <label for="filter-in-stock-${props.filterItem.id}">
                              ${props.filterItem.label}
                            </label>
                          </div>
                        `
                      : html`
                          <span
                            class="filter-checkbox-and-label"
                            data-tooltip-parent
                          >
                            <input
                              type="checkbox"
                              id="${checkboxId}"
                              class="checkbox collection-filters__sort-dropdown-item-radio filter-type-${cleanFilterId}"
                              name="sort-${props.filterItem.id}"
                              checked=${props.filterItem.selected}
                              data-dark-checkmark=${darkCheckmarkColors.has(
                                swatchName
                              )}
                              style="--swatch: var(--color-swatch-${swatchName});"
                            />
                            <span class="filter-item-label-and-count">
                              <label
                                for="${checkboxId}"
                                class="filter-item-label"
                              >
                                ${props.filterItem.label}
                                ${tooltipDescription
                                  ? html`
                                      <!-- Desktop tooltip icon -->

                                      <div
                                        aria-describedby=${`filter-${filterHandle}-${propsLabelData}-tooltip-desktop`}
                                        data-filter-option-tooltip-icon
                                        data-filter-option-tooltip-icon-desktop
                                        data-filter-option-toplevel-tooltip
                                        class="collection-filter-drawer__filter-tooltip-icon hidden--sm"
                                        tabindex="0"
                                        onclick=${(e) => e.stopPropagation()}
                                      >
                                        <span class="visually-hidden"
                                          >${props.filterItem.label}</span
                                        >
                                        <svg
                                          width="16"
                                          height="16"
                                          aria-hidden="true"
                                        >
                                          <use xlink:href="#icon-info"></use>
                                        </svg>
                                      </div>

                                      <!-- Desktop tooltip content -->
                                      <div
                                        id=${`filter-${filterHandle}-${propsLabelData}-tooltip-desktop`}
                                        role="tooltip"
                                        data-filter-option-tooltip-content-desktop
                                        class="collection-filter-drawer__filter-tooltip-content hidden--sm"
                                      >
                                        <div
                                          class="collection-filter-drawer__filter-tooltip-heading"
                                        >
                                          ${props.filterItem.label}
                                        </div>
                                        <div
                                          class="collection-filter-drawer__filter-tooltip-description"
                                        >
                                          ${tooltipDescription}
                                        </div>
                                      </div>

                                      <!-- Mobile trigger -->
                                      <hh-broadcast
                                        event="modal"
                                        data=${JSON.stringify({
                                          id: `filter-${filterHandle}-${propsLabelData}-tooltip`,
                                        })}
                                        class="hidden--md hidden--lg"
                                        tabindex="0"
                                        onclick=${(e) => e.stopPropagation()}
                                      >
                                        <div
                                          data-filter-option-tooltip-icon
                                          data-filter-option-tooltip-icon-mobile
                                          data-filter-option-toplevel-tooltip
                                          class="collection-filter-drawer__filter-tooltip-icon"
                                        >
                                          <svg
                                            width="16"
                                            height="16"
                                            aria-hidden="true"
                                          >
                                            <use xlink:href="#icon-info"></use>
                                          </svg>
                                        </div>
                                      </hh-broadcast>

                                      <!-- Mobile modal -->
                                      <hh-modal
                                        id=${`filter-${filterHandle}-${propsLabelData}-tooltip`}
                                        show-close="false"
                                        for-data-filter-option-tooltip="true"
                                        data-filter-option-tooltip-content-mobile
                                        class="hidden--md hidden--lg"
                                      >
                                        <div
                                          class="collection-filter-drawer__filter-tooltip-content-mobile"
                                          tabindex="0"
                                        >
                                          <div
                                            class="collection-filter-drawer__filter-tooltip-heading"
                                          >
                                            ${props.filterItem.label}
                                          </div>
                                          <div
                                            class="collection-filter-drawer__filter-tooltip-description"
                                          >
                                            ${tooltipDescription}
                                          </div>
                                        </div>
                                      </hh-modal>
                                    `
                                  : ''}
                              </label>
                            </span>
                          </span>
                        `}
                    ${props.children}
                  </li>
                `
              : null}
          `
        },
      },

      products: {
        render: function (html, args) {
          var props = args.props
          var helpers = props.helpers
          var products = helpers.getProducts()

          return html`
            <div
              class=${`products search-landing__results-list ${props.className}`}
            >
              ${products.map(
                (product, index) =>
                  html`<${args.templates.product}
                    key=${product.id}
                    product=${product}
                  />`
              )}
            </div>
          `
        },
      },

      product: {
        callbacks: {
          afterInitialRender: function (helpers, props) {
            if (
              window.yotpo &&
              typeof window.yotpo.initWidgets === 'function'
            ) {
              window.yotpo.initWidgets()
            }

            if (
              typeof window.yotpoWidgetsContainer?.initWidgets === 'function'
            ) {
              window.yotpoWidgetsContainer?.initWidgets()
            }
          },
        },
        render: function (html, args) {
          var { product, helpers } = args.props
          const images = product.images?.slice(0, 3) || []

          const productUrl = helpers
            .getTemplateOptions('product')
            .productPageUrl(product)

          /* ✅ SAFE SPLIT FUNCTION */
          const splitTitle = (title, value) => {
            if (!value) return { before: title, after: '' }

            // escape + flexible spacing
            const escaped = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
            const flexible = escaped.replace(/\s+/g, '\\s?')

            const regex = new RegExp(`(.*?)\\b${flexible}\\b(.*)`, 'i')
            const match = title.match(regex)

            if (!match) {
              return { before: title, after: '' }
            }

            return {
              before: match[1].trim(),
              after: match[2].trim(),
            }
          }

          let cleanTitle = product.title
          let productSubtitle = ''

          const caseDiameter =
            product.metafields?.specs?.case_diameter?.value?.[0]
          const bandMaterial =
            product.metafields?.specs?.band_material?.value?.[0]

          /* ✅ PRIORITY 1: case_diameter */
          if (caseDiameter) {
            const { before, after } = splitTitle(product.title, caseDiameter)

            cleanTitle = before

            if (!after || before === after) {
              productSubtitle = caseDiameter
            } else {
              productSubtitle = `${caseDiameter} ${after}`.trim()
            }
          } else if (bandMaterial) {
            /* ✅ PRIORITY 2: band_material */
            const { before, after } = splitTitle(product.title, bandMaterial)

            cleanTitle = before

            if (!after || before === after) {
              productSubtitle = bandMaterial
            } else {
              productSubtitle = `${bandMaterial} ${after}`.trim()
            }
          }

          const colorsCount =
            (product.metafields?.merchandise?.variants?.value?.length || 0) > 0
              ? product.metafields.merchandise.variants.value.length + 1
              : 0

          const isDesktop = window.innerWidth >= 990

          return html`
            <div class="product-card" data-product-id="${product.id}">
              <div
                class="search-landing__results-item product-card__media-wrapper exclude-tagalys-css-reset"
              >
                ${(() => {
                  const badgeEntries = Object.entries(badge_map || {})
                    .map(([key, value]) => ({
                      key,
                      ...value,
                    }))
                    .sort((a, b) => (a.priority || 0) - (b.priority || 0))

                  const badges = []
                  let badgeCount = 0

                  for (const badge of badgeEntries) {
                    if (badgeCount >= 2) break

                    const hasTag = product.tags?.includes(badge.tag_reference)

                    if (!hasTag) continue

                    badges.push(html`
                      <div
                        class="product-badge__item utility exclude-tagalys-css-reset"
                        id="product-badge-${badge.key}"
                        style="
          --badge-font-color:${badge.color};
          --badge-border-color:${badge.border_color};
          ${badge.background_color
                          ? `--badge-background-color:${badge.background_color};`
                          : ''}
        "
                      >
                        ${badge.label
                          ? html`
                              <span class="product-badge__label"
                                >${badge.label}</span
                              >
                            `
                          : ''}
                        ${badge.icon
                          ? html`
                              <span
                                class="${badge.label
                                  ? 'product-badge__icon'
                                  : 'product-badge__icon product-badge__icon--no-label'}"
                                style="
                  -webkit-mask:url(${badge.icon}) no-repeat center / contain;
                  mask:url(${badge.icon}) no-repeat center / contain;
                  background-color:${badge.color};
                  width:${badge.label ? 12 : 35}px;
                  height:${badge.label ? 12 : 35}px;
                  display:inline-block;
                "
                              >
                                <span style="opacity:0;">
                                  <img
                                    src="${badge.icon}"
                                    width="${badge.label ? 12 : 35}"
                                    height="${badge.label ? 12 : 35}"
                                  />
                                </span>
                              </span>
                            `
                          : ''}
                      </div>
                    `)

                    badgeCount++
                  }

                  if (!badges.length) return ''

                  return html`
                    <div class="search-product-badge exclude-tagalys-css-reset">
                      ${badges}
                    </div>
                  `
                })()}

                <!-- SPLIDE START -->
                <search-image-carousel>
                  <div
                    class="splide product-card__media-splide js-carousel-container"
                    role="group"
                    id="splide-${product.id}"
                  >
                    ${images.length > 1
                      ? html`
                          <ul
                            class="splide__pagination product-card__media-splide-pagination"
                          ></ul>
                        `
                      : ''}

                    <div class="splide__track">
                      <ul class="splide__list search-recomm-product-list">
                        ${images.map((image, index) => {
                          const isPng = /\.png(\?|$)/i.test(image.src)
                          const imgClass = isPng
                            ? 'product-card__image'
                            : 'product-card__image product-card__image-jpg'

                          const loading = index === 0 ? 'eager' : 'lazy'

                          return html`
                            <li
                              class="splide__slide"
                              key="${product.id}-${image.position}"
                            >
                              <a
                                id="product-${product.id}-${image.position}"
                                href="${productUrl}"
                                aria-label="${image.alt || product.title}"
                                data-product-card-link
                              >
                                <div
                                  class="product-card__image-wrapper exclude-tagalys-css-reset"
                                >
                                  <img
                                    src="${image.src}"
                                    width="400"
                                    height="500"
                                    class="${imgClass}"
                                    loading="${loading}"
                                    alt="${image.alt || product.title}"
                                  />
                                </div>
                              </a>
                            </li>
                          `
                        })}
                      </ul>
                    </div>

                    <div
                      class="splide__arrows product-card__media-splide-arrows 
                            ${images?.length > 1
                        ? ''
                        : 'product-card__media-splide-arrows-hide'}"
                    >
                      <button
                        type="button"
                        class="splide__arrow splide__arrow--prev button button--action-circle product-card__media-splide-arrow"
                        aria-label="Previous"
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          aria-hidden="true"
                        >
                          <use
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xlink:href="#icon-arrow-left"
                          ></use>
                        </svg>
                      </button>
                      <button
                        type="button"
                        class="splide__arrow splide__arrow--next button button--action-circle product-card__media-splide-arrow"
                        aria-label="Next"
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          aria-hidden="true"
                        >
                          <use
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xlink:href="#icon-arrow-right"
                          ></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </search-image-carousel>
                <!-- SPLIDE END -->

                <div
                  class=${isDesktop
                    ? 'product-card__compare-holder'
                    : 'product-card__compare-holder--mobile'}
                ></div>
              </div>

              <div class="product-card__details">
                <a
                  class="search-landing__product-card-title exclude-tagalys-css-reset"
                >
                  ${cleanTitle}
                </a>

                ${productSubtitle
                  ? html`<div
                      class="search-landing__product-card__subtitle exclude-tagalys-css-reset"
                    >
                      ${productSubtitle}
                      ${theme_style === 'guess' &&
                      colorsCount &&
                      !Number.isNaN(colorsCount)
                        ? ` | ${colorsCount} Colors`
                        : ''}
                    </div>`
                  : ''}

                <div
                  class="search-landing__product-card-price exclude-tagalys-css-reset"
                >
                  <span
                    class="exclude-tagalys-css-reset search-product-price 
                        ${product.compare_at_price > product.price
                      ? 'search-product-price--sale'
                      : ''}"
                  >
                    ${helpers.formatCurrency(product.price)}
                  </span>

                  ${product.compare_at_price > product.price
                    ? html`
                        <s class="price-item price-item--slashed">
                          ${helpers.formatCurrency(product.compare_at_price)}
                        </s>
                      `
                    : ''}
                </div>

                <div
                  class="yotpo-widget-instance product-card__yotpo-widget-instance"
                  data-yotpo-instance-id=${yotpo_stars_instance_id}
                  data-yotpo-product-id=${product.id}
                  data-yotpo-cart-product-id=${product.id}
                  data-yotpo-section-id="page"
                ></div>
              </div>

              <div
                class=${!isDesktop
                  ? 'product-card__compare-holder'
                  : 'product-card__compare-holder--desktop'}
              ></div>
            </div>
          `
        },
      },

      noResults: {
        options: {
          widgets: [{ recommendationId: tagalysConfig.recommendation }],
        },
      },
    }

    const shopifySearchResultsParams = Object.assign({}, searchResultsParams, {
      sort_options: shopifySearchSortOptions,
    })

    const shopifySearchResultsTemplates = Object.assign(
      {},
      searchResultsTemplates,
      {
        pagination: {
          options: {
            showLoadNextAfterEvery: 1,
          },

          render: function (html, args) {
            var props = args.props || {}
            var helpers = props.helpers

            if (helpers?.canLoadNextResults?.(props?.showLoadNextAfterEvery)) {
              return html`<${args.templates.loadNext} />`
            }

            return null
          },
        },
      }
    )

    function initializeShopifySearchResults() {
      return Tagalys.UIWidgets.ShopifySearchResults.init(
        searchResultsSelector,
        {
          params: shopifySearchResultsParams,
          templates: shopifySearchResultsTemplates,
          callbacks: searchResultsCallbacks,
        }
      )
    }

    Tagalys.UIWidgets.SearchResults.init(searchResultsSelector, {
      params: searchResultsParams,
      failover: initializeShopifySearchResults,
      templates: searchResultsTemplates,
      callbacks: searchResultsCallbacks,
    })
  })
}
